var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniswap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 25.5598C19.9361 25.5598 25.5588 19.937 25.5588 13.0011C25.5588 6.0651 19.9361 0.442383 13.0001 0.442383C6.06412 0.442383 0.441406 6.0651 0.441406 13.0011C0.441406 19.937 6.06412 25.5598 13.0001 25.5598Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1893 16.037C23.8314 21.506 18.8891 25.5594 13.0001 25.5594C11.9831 25.5594 10.9944 25.4385 10.0475 25.2103C15.8112 24.5009 18.267 21.3155 18.353 21.1375C18.3539 21.1354 18.3554 21.1334 18.3569 21.1314C18.3594 21.1282 18.3618 21.125 18.3618 21.121C20.0024 18.2579 18.4876 15.8219 18.0618 15.2316C18.0264 15.1802 17.993 15.1255 17.9594 15.0706C17.9375 15.0347 17.9156 14.9988 17.8929 14.9635C16.8691 13.3858 13.8108 12.3024 13.8108 12.3024C16.2491 15.3375 12.4747 16.6427 12.4747 16.6427C8.16088 18.4532 6.59863 18.5635 6.59863 18.5635C3.6672 18.3495 4.57741 16.293 4.57741 16.293C4.66126 15.9719 8.08144 10.9785 8.08144 10.9785L1.76514 7.85507L9.11522 9.46035C9.89414 7.64434 10.8805 7.88375 10.9908 7.91575V7.90802L10.1997 6.34136C12.1349 5.72904 14.0215 6.06002 14.0215 6.06002L14.411 7.68406C14.4121 7.67854 14.6846 6.10746 14.6846 6.10746C15.4489 5.83664 17.8595 6.80202 18.2012 6.93885C18.227 6.94918 18.241 6.95479 18.2416 6.95479L17.6899 8.55896L18.8484 7.25378C21.9449 8.70861 23.2915 11.1406 23.9003 12.2399C23.9531 12.3353 24.0003 12.4206 24.0427 12.4944C24.1268 12.6419 24.2014 12.7939 24.276 12.9461C24.2923 12.9794 24.3087 13.0127 24.3251 13.046C24.7335 13.8721 25.0082 15.0057 25.1893 16.037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6615 12.2102L9.91173 13.522C9.91173 13.522 9.37112 12.8788 10.0662 12.3382C10.3004 12.1857 10.569 12.0941 10.8476 12.0718C11.1262 12.0494 11.406 12.097 11.6615 12.2102Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8223 25.503C13.1631 25.1898 14.558 24.6392 15.9357 23.7446C21.3406 20.2372 19.2852 16.4176 18.492 15.3375C18.3462 15.1365 18.2114 14.9276 18.0882 14.712C17.2651 13.2667 13.814 12.2969 13.814 12.2969C14.7573 13.4774 14.5863 14.1725 14.5863 14.1725C14.4937 16.0359 12.4239 16.6736 12.4239 16.6736C12.4239 16.6736 14.6923 18.3164 13.1046 21.8226C12.3714 23.4419 10.1123 24.1655 7.89307 24.4755C9.11257 25.019 10.4347 25.3739 11.8223 25.503Z",
    fill: "#C2FBD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.882627C6.30776 0.882627 0.882627 6.30776 0.882627 13C0.882627 19.6922 6.30776 25.1174 13 25.1174C19.6922 25.1174 25.1174 19.6922 25.1174 13C25.1174 6.30776 19.6922 0.882627 13 0.882627ZM0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 1.48791C6.64227 1.48791 1.4884 6.64179 1.4884 12.9994C1.4884 19.357 6.64227 24.5109 12.9999 24.5109C19.3575 24.5109 24.5114 19.357 24.5114 12.9994C24.5114 6.64179 19.3575 1.48791 12.9999 1.48791ZM0.649902 12.9994C0.649902 6.1787 6.17919 0.649414 12.9999 0.649414C19.8206 0.649414 25.3499 6.1787 25.3499 12.9994C25.3499 19.8201 19.8206 25.3494 12.9999 25.3494C6.17919 25.3494 0.649902 19.8201 0.649902 12.9994Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.369,
    y1: 15.1812,
    x2: 0.630068,
    y2: 10.8199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C58C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 181.36,
    y1: 180.891,
    x2: 215.838,
    y2: 180.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C58C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.1633,
    y1: 15.1433,
    x2: 0.835429,
    y2: 10.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C58C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniswap);
export default __webpack_public_path__ + "static/media/uniswap.dfe90dcc.svg";
export { ForwardRef as ReactComponent };